import { render, staticRenderFns } from "./marksEntrySub.vue?vue&type=template&id=5827e972&scoped=true&"
import script from "./marksEntrySub.vue?vue&type=script&lang=js&"
export * from "./marksEntrySub.vue?vue&type=script&lang=js&"
import style0 from "./marksEntrySub.vue?vue&type=style&index=0&id=5827e972&lang=scss&scoped=true&"
import style1 from "./marksEntrySub.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./marksEntrySub.vue?vue&type=style&index=2&id=5827e972&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5827e972",
  null
  
)

export default component.exports